import { render, staticRenderFns } from "./MerchantMenuList.vue?vue&type=template&id=06492ce6&scoped=true&"
import script from "./MerchantMenuList.vue?vue&type=script&lang=js&"
export * from "./MerchantMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06492ce6",
  null
  
)

export default component.exports